
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {TradeHistoryTimeRangeGetResponse} from './TradeHistoryTimeRangeGetResponse';
import {TransactionType} from '../entity/TransactionType';
import {FieldModelTransactionType} from '../entity/TransactionType';

/**
 * TradeHistoryTimeRangeGetRequest struct
 */
class TradeHistoryTimeRangeGetRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!Date=} requestFrom
   * @param {!Date=} requestTo
   * @param {UUID=} platformId
   * @param {!Set=} transactionTypes
   * @constructor
   */
  constructor (parent = new Request(), requestFrom = new Date(0), requestTo = new Date(0), platformId = null, transactionTypes = new Set()) {
    super()
    super.copy(parent)
    this.RequestFrom = requestFrom
    this.RequestTo = requestTo
    this.PlatformId = platformId
    this.TransactionTypes = transactionTypes
  }

  /**
   * Copy struct (shallow copy)
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @param {!TradeHistoryTimeRangeGetRequest} other Other struct
   * @returns {!TradeHistoryTimeRangeGetRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.RequestFrom != null) {
      if (other.RequestFrom instanceof Date) {
        this.RequestFrom = new Date(other.RequestFrom.getTime())
      } else {
        this.RequestFrom = new Date(Math.round(other.RequestFrom / 1000000))
      }
    } else {
      this.RequestFrom = null
    }
    if (other.RequestTo != null) {
      if (other.RequestTo instanceof Date) {
        this.RequestTo = new Date(other.RequestTo.getTime())
      } else {
        this.RequestTo = new Date(Math.round(other.RequestTo / 1000000))
      }
    } else {
      this.RequestTo = null
    }
    if (other.PlatformId != null) {
      this.PlatformId = new UUID(other.PlatformId)
    } else {
      this.PlatformId = null
    }
    if (other.TransactionTypes != null) {
      this.TransactionTypes = new Set()
      for (let item of other.TransactionTypes) {
        if (item != null) {
          let tempItem
          tempItem = TransactionType.fromObject(item)
          this.TransactionTypes.add(tempItem)
        } else {
          this.TransactionTypes.add(null)
        }
      }
    } else {
      this.TransactionTypes = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @returns {!TradeHistoryTimeRangeGetRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new TradeHistoryTimeRangeGetRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new TradeHistoryTimeRangeGetRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @param {!TradeHistoryTimeRangeGetRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof TradeHistoryTimeRangeGetRequest)) {
      throw new TypeError('Instance of TradeHistoryTimeRangeGetRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      RequestFrom: ((this.RequestFrom != null) ? (this.RequestFrom.getTime() * 1000000) : null),
      RequestTo: ((this.RequestTo != null) ? (this.RequestTo.getTime() * 1000000) : null),
      PlatformId: ((this.PlatformId != null) ? this.PlatformId.toString() : null),
      TransactionTypes: ((this.TransactionTypes != null) ? Array.from(this.TransactionTypes, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return TradeHistoryTimeRangeGetRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!TradeHistoryTimeRangeGetRequest} other Object value
   * @returns {!TradeHistoryTimeRangeGetRequest} Created struct
   */
  static fromObject (other) {
    return new TradeHistoryTimeRangeGetRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return TradeHistoryTimeRangeGetRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!TradeHistoryTimeRangeGetRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4109
  }
}

export { TradeHistoryTimeRangeGetRequest };

/**
 * Fast Binary Encoding TradeHistoryTimeRangeGetRequest field model
 */
class FieldModelTradeHistoryTimeRangeGetRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.RequestFrom = new fbe.FieldModelTimestamp(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.RequestTo = new fbe.FieldModelTimestamp(buffer, this.RequestFrom.fbeOffset + this.RequestFrom.fbeSize)
    this.PlatformId = new fbe.FieldModelOptional(new fbe.FieldModelUUID(buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize), buffer, this.RequestTo.fbeOffset + this.RequestTo.fbeSize)
    this.TransactionTypes = new fbe.FieldModelSet(new FieldModelTransactionType(buffer, this.PlatformId.fbeOffset + this.PlatformId.fbeSize), buffer, this.PlatformId.fbeOffset + this.PlatformId.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.RequestFrom.fbeSize + this.RequestTo.fbeSize + this.PlatformId.fbeSize + this.TransactionTypes.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.RequestFrom.fbeExtra + this.RequestTo.fbeExtra + this.PlatformId.fbeExtra + this.TransactionTypes.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelTradeHistoryTimeRangeGetRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4109
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestFrom.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.RequestTo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PlatformId.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.TransactionTypes.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!TradeHistoryTimeRangeGetRequest} fbeValue Default value, defaults is new TradeHistoryTimeRangeGetRequest()
   * @returns {!TradeHistoryTimeRangeGetRequest} TradeHistoryTimeRangeGetRequest value
   */
  get (fbeValue = new TradeHistoryTimeRangeGetRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!TradeHistoryTimeRangeGetRequest} fbeValue TradeHistoryTimeRangeGetRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.RequestFrom.fbeSize) <= fbeStructSize) {
      fbeValue.RequestFrom = this.RequestFrom.get()
    } else {
      fbeValue.RequestFrom = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestFrom.fbeSize

    if ((fbeCurrentSize + this.RequestTo.fbeSize) <= fbeStructSize) {
      fbeValue.RequestTo = this.RequestTo.get()
    } else {
      fbeValue.RequestTo = new Date(0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.RequestTo.fbeSize

    if ((fbeCurrentSize + this.PlatformId.fbeSize) <= fbeStructSize) {
      fbeValue.PlatformId = this.PlatformId.get()
    } else {
      fbeValue.PlatformId = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PlatformId.fbeSize

    if ((fbeCurrentSize + this.TransactionTypes.fbeSize) <= fbeStructSize) {
      this.TransactionTypes.get(fbeValue.TransactionTypes)
    } else {
      fbeValue.TransactionTypes.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.TransactionTypes.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {!TradeHistoryTimeRangeGetRequest} fbeValue TradeHistoryTimeRangeGetRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelTradeHistoryTimeRangeGetRequest}
   * @param {TradeHistoryTimeRangeGetRequest} fbeValue TradeHistoryTimeRangeGetRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.RequestFrom.set(fbeValue.RequestFrom)
    this.RequestTo.set(fbeValue.RequestTo)
    this.PlatformId.set(fbeValue.PlatformId)
    this.TransactionTypes.set(fbeValue.TransactionTypes)
  }
}

export { FieldModelTradeHistoryTimeRangeGetRequest };

/**
 * Fast Binary Encoding TradeHistoryTimeRangeGetRequest model
 */
class TradeHistoryTimeRangeGetRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelTradeHistoryTimeRangeGetRequest(this.buffer, 4)
  }

  /**
   * Get the TradeHistoryTimeRangeGetRequest model
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!FieldModelTradeHistoryTimeRangeGetRequest} model TradeHistoryTimeRangeGetRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return TradeHistoryTimeRangeGetRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelTradeHistoryTimeRangeGetRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @param {!TradeHistoryTimeRangeGetRequest} value TradeHistoryTimeRangeGetRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @param {!TradeHistoryTimeRangeGetRequest} value TradeHistoryTimeRangeGetRequest value, defaults is new TradeHistoryTimeRangeGetRequest()
   * @return {!object} Deserialized TradeHistoryTimeRangeGetRequest value and its size
   */
  deserialize (value = new TradeHistoryTimeRangeGetRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new TradeHistoryTimeRangeGetRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new TradeHistoryTimeRangeGetRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!TradeHistoryTimeRangeGetRequestModel}
   * @param {!number} prev Previous TradeHistoryTimeRangeGetRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { TradeHistoryTimeRangeGetRequestModel };
TradeHistoryTimeRangeGetRequest.__has_response = true;
TradeHistoryTimeRangeGetRequest.__response_class = TradeHistoryTimeRangeGetResponse;
